import React, { FC, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './absence-actions-modal.module.css';
import { GeneralContext } from '../../providers/general-provider';
import { initialModalContent } from '../../providers/general-provider';
import SubmitButton from '../submit-button/submit-button';

const AbsenceActionsModal: FC<{ classroomUuid: string }> = ({ classroomUuid }) => {
  const navigate = useNavigate();
  const { setModalContent } = useContext(GeneralContext);

  const handleNavigate = (path: string) => {
    setModalContent(initialModalContent);
    navigate(path);
  };

  return (
    <div className={styles.actionsContainer}>
      <SubmitButton
        value="registrar faltas"
        variant="primary"
        onClick={() => handleNavigate(`/diarios/turma/${classroomUuid}/registrar-faltas`)}
        buttonStyle={{width: '100%', marginRight: '0'}}
      />
      <SubmitButton
        value="justificar faltas"
        variant="secondary"
        onClick={() => handleNavigate(`/diarios/turma/${classroomUuid}/justificar-faltas`)}
        buttonStyle={{width: '100%', marginLeft: '0'}}
      />
    </div>
  );
};

export default AbsenceActionsModal;
